import {HelpfulPoll} from 'components/HelpfulPoll';
import {ManagerFeedbackAssistant} from 'components/manager_feedback/manager_feedback';
import {useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {ANALYTICS_EVENTS, sendTimeSpentEvent} from 'utilities/analytics';

export const ManagerFeedback = () => {
  useEffect(() => {
    const startTime = Date.now();
    return () => {
      const endTime = Date.now();
      const timeSpentSec = (endTime - startTime) / 1000;
      sendTimeSpentEvent(
        ANALYTICS_EVENTS.MANAGER_ASSISTANT.TIME_SPENT,
        timeSpentSec,
        'Manager Assistant'
      );
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Manager Assistant - SPRiTEs-GPT</title>
      </Helmet>
      <ManagerFeedbackAssistant />
      <HelpfulPoll />
    </>
  );
};
